import { render, staticRenderFns } from "./new_input.vue?vue&type=template&id=e1873086&scoped=true"
import script from "./new_input.vue?vue&type=script&lang=js"
export * from "./new_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1873086",
  null
  
)

export default component.exports